import Call from '../Call.v2';
import {objToQs} from "../Utils";

const History = {
    get(filters) {
        return Call(`history?${objToQs(filters)}`);
    },

    getNames() {
        return Call(`history/names`);
    },
}

export default History;



// WEBPACK FOOTER //
// ./src/services/API/components/History.js